<template>
    <select class="form-control" name="position" id="position" @change="onChange($event)">
		<option v-for="index in 10" :key="index" :value="index" :selected="selectedValue == index" >{{ index }}</option>
	</select>
</template>

<script>
    export default {
        name: 'position-selector',
		    emits: ['update'],
        props: {
        	selectedValue : {
            type: Number,
            default: 1
          }
        },
        data () {
          return {
            value : '',
          };
        },
        methods: {
          onChange(event) {
            let optionSelected = event.target.value;
            this.value = optionSelected;
            this.$emit('update', optionSelected);
          }
        }
    }
</script>
